export const compareStringByKey = (key, reverse) => (obj1, obj2) => {
  if (obj1[key] < obj2[key]) {
    return reverse ? 1 : -1;
  }
  if (obj1[key] > obj2[key]) {
    return reverse ? -1 : 1;
  }
  return 0;
};

export const hashString = str => {
  let hash = 0;
  let i = 0;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i += 1) {
    const chr = str.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return Math.abs(hash).toString(16);
};



// WEBPACK FOOTER //
// ./src/utils/stringUtil.js